// todo: this should be generated at build time.
module.exports = '0.8.1';



//////////////////
// WEBPACK FOOTER
// ./node_modules/vivagraphjs/src/version.js
// module id = 596
// module chunks = 0